<template>
  <div>
    <a @click="kakaoshare">
      <img class="social-icon" src="../assets/icon/kakaotalk-icon.svg" alt="" />
    </a>
  </div>
</template>

<script>
export default {
  name: "Share",
  props: ["url", "title", "image"],
  methods: {
    async kakaoshare() {
      const res = await this.$KakaoSDK.Link.uploadImage({
        file: [this.image]
      });
      const imageUrl = res?.infos?.original?.url;

      this.$KakaoSDK.Link.sendDefault({
        objectType: "feed",
        content: {
          title: this.title,
          description: "spready.net",
          imageUrl,
          link: {
            mobileWebUrl: this.url,
            webUrl: this.url
          }
        }
      });
    }
  }
};
</script>

<style>
.social-icon {
  align-items: center;
  width: 50px;
  height: 50px;
  margin: 0 5px;
}
</style>
